<template>
  <div>
    <h1>Avengers vs Thanos</h1>
    <section class="row">
      <div class="small-6 columns">
        <h1 class="text-center">Avengers</h1>
        <div class="healthbar">
          <div
            class="healthbar text-center"
            style="background-color: green; margin: 0; color: white;"
            :style="{ width: avengersHealth + '%' }"
          >
            {{ avengersHealth }}
          </div>
        </div>
      </div>
      <div class="small-6 columns">
        <h1 class="text-center">Thanos</h1>
        <div class="healthbar">
          <div
            class="healthbar text-center"
            style="background-color: green; margin: 0; color: white;"
            :style="{ width: thanosHealth + '%' }"
          >
            {{ thanosHealth }}
          </div>
        </div>
      </div>
    </section>
    <section class="row controls" v-if="gameIsRunning">
      <div class="small-12 columns">
        <button id="attack" @click="attack">ATTACK</button>
        <button id="special-attack" @click="specialAttack">
          SPECIAL ATTACK
        </button>
        <button id="heal" @click="heal">HEAL</button>
        <button id="give-up" @click="giveUp">GIVE UP</button>
      </div>
    </section>
    <section class="row controls" v-else>
      <div class="small-12 columns">
        <button id="start-game" @click="startGame">NEW GAME</button>
      </div>
    </section>

    <section class="row log">
      <div class="small-12 columns">
        <ul>
          <li
            v-for="turn in turns"
            :key="turn.id"
            :class="{
              'avengers-turn': turn.isPlayer,
              'thanos-turn': !turn.isPlayer
            }"
          >
            {{ turn.text }}
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      avengersHealth: 100,
      thanosHealth: 100,
      gameIsRunning: false,
      turns: []
    };
  },
  methods: {
    startGame: function() {
      this.gameIsRunning = true;
      this.avengersHealth = 100;
      this.thanosHealth = 100;
      this.turns = [];
    },
    attack: function() {
      var damage = 5;

      this.thanosHealth = this.thanosHealth - damage;

      this.turns.unshift({
        isPlayer: true,
        text: `Avengers hits Thanos for ${damage}. Thanos remaining health is ${this.thanosHealth}.`
      });

      this.avengersHealth = this.avengersHealth - damage - 2;

      this.turns.unshift({
        isPlayer: false,
        text: `Thanos hits Avengers for ${damage +
          2}. Avengers remaining health is ${this.avengersHealth}.`
      });

      this.checkEndGame();
    },
    specialAttack: function() {
      var damage = 10;
      this.thanosHealth = this.thanosHealth - damage;

      this.turns.unshift({
        isPlayer: true,
        text: `Avengers hits Thanos hard for ${damage}. Thanos remaining health is ${this.thanosHealth}.`
      });
    },
    heal: function() {
      this.avengersHealth = this.avengersHealth + 10;

      this.turns.unshift({
        isPlayer: true,
        text: `Avengers heals for 10. Avengers remaining health is ${this.avengersHealth}.`
      });
    },
    giveUp: function() {
      this.gameIsRunning = false;
      alert("You lost!");
    },
    checkEndGame: function() {
      debugger;
      if (this.thanosHealth <= 0 && this.avengersHealth <= 0) {
        this.thanosHealth = 0;
        this.avengersHealth = 0;
        alert("Both lost!");
        this.gameIsRunning = false;
        return;
      }

      if (this.thanosHealth <= 0) {
        this.thanosHealth = 0;
        alert("You won!");
        this.gameIsRunning = false;
        return;
      }

      if (this.avengersHealth <= 0) {
        this.avengersHealth = 0;
        alert("You lost!");
        this.gameIsRunning = false;
        return;
      }
    }
  }
};
</script>

<style scoped>
.text-center {
  text-align: center;
}

.healthbar {
  width: 80%;
  height: 40px;
  background-color: #eee;
  margin: auto;
  transition: width 500ms;
}

.controls,
.log {
  margin-top: 30px;
  text-align: center;
  padding: 10px;
  border: 1px solid #ccc;
  box-shadow: 0px 3px 6px #ccc;
}

.turn {
  margin-top: 20px;
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 22px;
}

.log ul {
  list-style: none;
  font-weight: bold;
  text-transform: uppercase;
}

.log ul li {
  margin: 5px;
}

.log ul .avengers-turn {
  color: blue;
  background-color: #e4e8ff;
}

.log ul .thanos-turn {
  color: red;
  background-color: #ffc0c1;
}

button {
  font-size: 20px;
  background-color: #eee;
  padding: 12px;
  box-shadow: 0 1px 1px black;
  margin: 10px;
}

#start-game {
  background-color: #aaffb0;
}

#start-game:hover {
  background-color: #76ff7e;
}

#attack {
  background-color: #ff7367;
}

#attack:hover {
  background-color: #ff3f43;
}

#special-attack {
  background-color: #ffaf4f;
}

#special-attack:hover {
  background-color: #ff9a2b;
}

#heal {
  background-color: #aaffb0;
}

#heal:hover {
  background-color: #76ff7e;
}

#give-up {
  background-color: #ffffff;
}

#give-up:hover {
  background-color: #c7c7c7;
}
</style>
